import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { ManifestLoader } from '../ManifestLoader';
import { PanelLoader } from '../PanelLoader';
import { ManifestHelpers } from '../helpers';
import { createEditorPlatformManifestServicesError, EditorPlatformManifestServicesErrorCode } from '../errors';
export class AbstractComponentFlow {
  constructor(dm, editorPointerAPI, manifestUrlResolver, manifestStore, panelStore, wixCLIIntegrationAPI) {
    this.dm = dm;
    this.editorPointerAPI = editorPointerAPI;
    this.manifestUrlResolver = manifestUrlResolver;
    this.manifestStore = manifestStore;
    this.panelStore = panelStore;
    this.wixCLIIntegrationAPI = wixCLIIntegrationAPI;
    _defineProperty(this, "type", void 0);
    _defineProperty(this, "panelLoader", new PanelLoader());
    _defineProperty(this, "manifestLoader", new ManifestLoader(this.manifestUrlResolver));
    _defineProperty(this, "manifestHelpers", new ManifestHelpers(this.dm, this.editorPointerAPI));
  }
  async _loadPanels(manifest, appData) {
    const nativeActions = (manifest == null ? void 0 : manifest.actions) ?? {};
    const customActions = (manifest == null ? void 0 : manifest.customActions) ?? {};
    const panels = {};
    const tasks = Object.entries({
      ...nativeActions,
      ...customActions
    }).map(async _ref => {
      var _action$execution;
      let [actionName, action] = _ref;
      const panelAction = action == null || (_action$execution = action.execution) == null ? void 0 : _action$execution.panel;
      if (!panelAction) {
        return;
      }
      const panelFactory = await this.panelLoader.load(panelAction, appData);
      if (!panelFactory) {
        return;
      }
      panels[actionName] = editorPointer => {
        const hostContext = this.wixCLIIntegrationAPI.getSDKHostContext({
          appDefinitionId: appData.appDefinitionId,
          contextBuilder: editorPointer ? builder => {
            builder.isStageBound(true);
            builder.withRuntimeMappings(false);
            builder.byEditorPointer(editorPointer, editorElement => {
              builder.withEditorElement(editorPointer, editorElement);
            });
          } : () => {}
        });
        const auth = this.wixCLIIntegrationAPI.getSDKAuth({
          appDefinitionId: appData.appDefinitionId
        });
        const panel = panelFactory({
          host: hostContext.getHost(),
          auth
        });

        // TODO: move to function
        let panelReactComponent;
        if (typeof panel === 'function') {
          panelReactComponent = /*#__PURE__*/React.createElement(panel);
        } else if (/*#__PURE__*/React.isValidElement(panel) ||
        // Already a React Element
        Array.isArray(panel) // Array of nodes (e.g. fragment)
        ) {
          panelReactComponent = panel;
        } else {
          throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.LoadComponentPanelError, `Panel factory has returned an unexpected value`);
        }
        return panelReactComponent;
      };
    });
    await Promise.all(tasks);
    return panels;
  }
}
//# sourceMappingURL=AbstractComponentFlow.js.map